var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.58667 11.3101C12.4814 11.3101 15.5704 13.5301 16.3053 16.2864C15.6672 16.4394 14.9528 16.5168 14.1733 16.5168H3C2.22055 16.5168 1.50618 16.4394 0.868079 16.2864C1.60298 13.5301 4.69196 11.3101 8.58667 11.3101Z",
    stroke: "#575757",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6092 4.77336C12.6092 7.00186 10.8089 8.80998 8.58584 8.80998C6.36276 8.80998 4.5625 7.00186 4.5625 4.77336C4.5625 2.54757 6.36005 0.75 8.58584 0.75C10.8116 0.75 12.6092 2.54757 12.6092 4.77336Z",
    stroke: "#575757",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user_icon.6bbe042b99cf013d5e38a2ae3d8ab24a.svg";
export { ForwardRef as ReactComponent };